// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {Object} Notification
 * @property {string} id
 * @property {string} type
 * @property {string} title
 * @property {string} body
 * @property {boolean} seen flag if seen by current user
 * @property {Object.<string,any>} meta
 */

const state = {
  /**
   * notifications list
   * @type {Notification[]}
   **/
  notifications: [],
  /**
   * notifications watcher's observable subscription
   * @type {import('rxjs').Subscription}
   **/
  notificationsSub: null,
  /**
   * list of newly emitted notifications
   * @type {Notification[]}
   **/
  notificationsNew: []
};

export default state;

/**
 * @param {state} state
 * @returns {number}
 */
export function unreadNotificationsCount (state) {
  return state.notifications.reduce((sum, n) => n.seen ? sum : sum + 1, 0);
}
